import { ReactNode, useState } from 'react';
import { ErrorBoundary } from 'react-error-boundary';
import Error500 from '~/components/Error500';
import { captureException } from '~/errorsLogging';

export interface IGlobalErrorBoundary {
  children?: ReactNode;
  isSupportedBrowser: boolean;
}

/**
 * @TODO: check in library https://github.com/bvaughn/react-error-boundary compatibility with react18
 * and if compatible, remove comment below.
 * This library has stopped receiving support, it's not really compatible with react18.
 * NOTE: children is not included in FC types anymore.
 *  */

const GlobalErrorBoundary: React.FC<IGlobalErrorBoundary> = ({
  children,
  isSupportedBrowser,
}) => {
  const [eventId, setEventId] = useState<null | string>(null);

  const handleError = (error: Error, info: { componentStack: string }) => {
    const newEventId = captureException(error, {
      errorInfo: info,
      isSupportedBrowser,
    });
    setEventId(newEventId);
  };

  return (
    // @ts-ignore
    <ErrorBoundary
      fallbackRender={() => <Error500 errorEventId={eventId} />}
      onError={handleError}
    >
      {children}
    </ErrorBoundary>
  );
};

export default GlobalErrorBoundary;
